export const FETCH_LANDINGS = "FETCH_LANDINGS";
